import { render, staticRenderFns } from "./headerbar.vue?vue&type=template&id=8bc8f7f4&scoped=true&"
import script from "./headerbar.vue?vue&type=script&lang=js&"
export * from "./headerbar.vue?vue&type=script&lang=js&"
import style0 from "./headerbar.vue?vue&type=style&index=0&id=8bc8f7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc8f7f4",
  null
  
)

export default component.exports